"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var for_company_banner_png_1 = __importDefault(require("images/banners/for_company_banner.png"));
var IMAGE_SRC = {
    for_company_banner: for_company_banner_png_1.default
};
var Basic = function (_a) {
    var linkPath = _a.linkPath, image = _a.image, alt = _a.alt;
    return (react_1.default.createElement("div", { className: "banners-BasicBanner" },
        react_1.default.createElement("a", { href: linkPath },
            react_1.default.createElement("img", { src: IMAGE_SRC[image], alt: alt, className: "banners-BasicBanner_Image lazyload" }))));
};
exports.default = Basic;
